<div class="flex flex-col items-center justify-center gap-5">
    <div class="spinner spinner-primary spinner-xl" *ngIf="loading"></div>

    <div class="flex flex-col items-center gap-5" *ngIf="!loading && !error">
        <iota-icon icon="check-circle" class="text-primary" size="7"></iota-icon>
        <h4 class="mb-0">{{ title }}</h4>

        <span *ngIf="!!successMessage">{{ successMessage }}</span>

        <div *ngIf="numberOfSuccessfulUploads">
            <b>{{ numberOfSuccessfulUploads }}</b
            >&nbsp;<span>{{ successfulUploadsSuffix }}</span>
        </div>
    </div>

    <div class="flex flex-col items-center gap-5" *ngIf="!loading && error">
        <iota-icon icon="x-circle" class="text-error" size="7"></iota-icon>
        <h4 class="mb-0">{{ errorTitle }}</h4>
        <span>{{ errorMessage }}</span>
    </div>
</div>
